export const init = () => {
  //Send virtual page on click on the Smart Suggest (ex : "https://www.decathlon.de/search?Ntt=expression recherchée")

  const targetNode = document.querySelector('.l-search-form');
  const config = { childList: true };

  if (!targetNode) return;
  const callback = mutationsList => {
    // eslint-disable-next-line no-restricted-syntax
    mutationsList.forEach(() => {
      const smartSuggest = document.querySelector('.search');
      if (smartSuggest) {
        smartSuggest.addEventListener('click', () => {
          const inputValue = document.getElementById('search-autocomplete')
            .value;
          const location = window.location.pathname.split('/')[1]
            ? `${window.location.pathname.split('/')[1]}/`
            : '';
          const pageName = `${
            window.location.origin
          }/${location}search?Ntt=${inputValue}`;

          CUBE.Analytics.sendPageView(pageName);
        });
      }
    });
  };

  // Créé une instance de l'observateur lié à la fonction de callback
  const observer = new MutationObserver(callback);

  // Commence à observer le noeud cible pour les mutations précédemment configurées
  if (targetNode) {
    observer.observe(targetNode, config);
  }
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/smart-suggest-tracker.js